// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1SSA9","footer":"styles_footer__NGDAY"};